
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { DeleteDialog } from "../Dialog/DeleteDialog.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { FormState__getValidation, BusinessUnitId } from "../../Shared/Shared.js";
import { Msg } from "./Types.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { singleton as singleton_1, ofArray, empty } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { TextValue, LabeledValue } from "../../Components/Text.js";
import { unwrap, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ImageWidget } from "../../Widgets/Image/ImageWidget.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewBusinessUnit } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

function BusinessUnitDetail(props) {
    let elems_4, elems_3, elems, Title_1, elems_2, elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    const isDeleteDialogOpen = patternInput_1[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(singleton_1((elems_4 = [createElement(DeleteDialog, {
        BusinessUnitId: new BusinessUnitId(parse(props.BusinessUnit.Id)),
        IsOpen: isDeleteDialogOpen,
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(6, []));
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_3 = [createElement(DetailViewHeader, {
        Badges: empty(),
        OnBack: () => {
            RouterModule_nav(ofArray(["business-units"]), 1, 1);
        },
        OnDelete: () => {
            setIsDeleteDialogOpen(!isDeleteDialogOpen);
        },
        OnEdit: () => {
            RouterModule_nav(ofArray(["business-units", props.BusinessUnit.Id, "edit"]), 1, 1);
        },
        Title: t("business_units.detail.title"),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems = [LabeledValue({
        Label: t("general.name"),
        Value: props.BusinessUnit.Name,
    }), LabeledValue({
        Label: t("general.description"),
        Value: props.BusinessUnit.Description,
    }), LabeledValue({
        Label: t("business_units.detail.parent_business_unit"),
        Value: defaultArg(props.BusinessUnit.ParentBusinessUnitName, ""),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(SectionContainer, (Title_1 = t("settings.protocol.title"), {
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_1 = toList(delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "",
            Text: t("general.image"),
        })), delay(() => {
            let ImageUrl, matchValue;
            return append(singleton(createElement(ImageWidget, (ImageUrl = defaultArg(props.BusinessUnit.ImageUrl, ""), {
                CanEditImage: (matchValue = props.UserData.Role, (matchValue === "system") ? true : ((matchValue === "toolManager") ? false : (!(matchValue === "user")))),
                ImageUrl: ImageUrl,
                OnDeleteImage: () => {
                    props.Dispatch(new Msg(1, []));
                },
                OnUploadImage: (file) => {
                    props.Dispatch(new Msg(0, [file]));
                },
            }))), delay(() => {
                const matchValue_1 = FormState__getValidation(props.FormState, t, "global");
                if (matchValue_1 == null) {
                    return empty_1();
                }
                else {
                    return singleton(createElement(ErrorAlert, {
                        Label: matchValue_1,
                    }));
                }
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))),
        Title: unwrap(Title_1),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

export function BusinessUnitDetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initViewBusinessUnit(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.BusinessUnitId, props.UserData], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.BusinessUnit;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(BusinessUnitDetail, {
            BusinessUnit: matchValue.fields[0],
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
            UserData: props.UserData,
        });
    }
}

